import { apiDelete, apiGet, apiPost, apiPut } from "./api-service";

export async function getAll() {
    try {
        const response = await apiGet('core', `information`);
        return response;
    } catch (e) { }
}

export async function departmentOfLabourAdd(informationBody:any) {
    try {

        const response = await apiPost('core', 'departmentoflabour', informationBody);

        return response;
    } catch (e) { }
}

export async function departmentOfLabourUpdate(id: number, informationBody:any) {
    try {
        const response = await apiPut('core', `departmentoflabour/${id}`, informationBody);

        return response;
    } catch (e) { }
}

export async function departmentOfLabourRemove(id: any) {
    try {
        return await await apiDelete('core', `departmentoflabour/${id}`);
    } catch (e) { }
}